import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { login as loginApi } from './LoginAPI';

const initialState = {
    //token: '',
    uid: '',
    name: '',
    isAdmin: false,
    //prjRoles: {},
    isLoggedIn: false,
    apiStatus: 'idle',
    statusText: ''
}

export const loginAsync = createAsyncThunk(
    'login/loginAsync',
    async (input, thunkAPI) => {
        //const response = await login(input);
        let res;
        try {
            res = loginApi(input);
        } catch (e) {
            thunkAPI.rejectWithValue({ errorMessage: 'Fetch error' });
            return;
        }

        //return response.data;
        //return JSON.parse(res.json());
        return res;
    }
);

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        login: (state, action) => {
            if (Boolean(action.payload.success)) {
                state.uid = action.payload.uid;
                //state.token = action.payload.token;
                state.name = action.payload.userName;
                state.isAdmin = Boolean(action.payload.isAdmin);
                //state.prjRoles = action.payload.prjRoles;
                state.isLoggedIn = true;
                state.statusText = 'ログインしました';
            } else {
                state.isLoggedIn = false;
                state.statusText = 'ログインに失敗しました';
            }
        },
        logout: state => {
            state.uid = '';
            //state.token = '';
            state.name = '';
            //state.prjRoles = {};
            state.isAdmin = false;
            state.isLoggedIn = false;
            state.statusText = 'ログアウトしました';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAsync.pending, (state) => {
                state.apiStatus = 'loading';
                state.statusText = 'ログイン中です';
            })
            .addCase(loginAsync.fulfilled, (state, action) => {
                state.apiStatus = 'idle';
                if (Boolean(action.payload.success)) {
                    state.uid = action.payload.uid;
                    //state.token = action.payload.token;
                    state.name = action.payload.userName;
                    state.isAdmin = Boolean(action.payload.isAdmin);
                    //state.prjRoles = action.payload.prjRoles;
                    state.isLoggedIn = true;
                    state.statusText = 'ログインしました';
                } else {
                    state.isLoggedIn = false;
                    state.statusText = 'ログインに失敗しました';
                }
            })
            .addCase(loginAsync.rejected, (state, action) => {
                state.apiStatus = 'idle';
                state.isLoggedIn = false;
                state.statusText = 'エラーが発生しました';
            })
            ;
    },
});

export const selectUid = (state) => state.login.uid;
//export const selectToken = (state) => state.login.token;
export const selectUserName = (state) => state.login.name;
export const selectIsAdmin = (state) => state.login.isAdmin;
//export const selectPrjRoles = (state) => state.login.PrjRoles;
export const selectIsLoggedIn = (state) => state.login.isLoggedIn;
export const selectApiStatus = (state) => state.login.apiStatus;
export const selectStatusText = (state) => state.login.statusText;

export const { login, logout } = loginSlice.actions;

export default loginSlice;

